export const SUPABASE_CONFIG = {
  URL: 'https://bidyqgtaszfgbvhkjiwk.supabase.co',
  ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJpZHlxZ3Rhc3pmZ2J2aGtqaXdrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU2NTI2OTQsImV4cCI6MjA1MTIyODY5NH0.T1PhX8x3dwl6KlJ3yWQyZoIsmZrUY_zlvSIxIDtDIWw'
} as const;

// Type for the config object
export type SupabaseConfig = typeof SUPABASE_CONFIG;

// Validate config
if (!SUPABASE_CONFIG.URL || !SUPABASE_CONFIG.ANON_KEY) {
  throw new Error('Missing Supabase configuration');
}